import koganAPI from '../../../apis/kogan-api';
export const registerTenant = (data) => koganAPI.post('tenant/register', data);
export const getTenantProfile = () => koganAPI.get('tenant/profile');
